/**
 * Slide-in panel that shows the Flutter web app in a phone-sized iframe.
 * Toggle button lives in the portal header; panel slides from the right.
 */

const PREVIEW_URL = import.meta.env.VITE_APP_PREVIEW_URL || 'http://localhost:8888';

export function AppPreviewToggle({ isOpen, onToggle }) {
  return (
    <button
      className={`btn btn-sm app-preview-toggle ${isOpen ? 'active' : ''}`}
      onClick={onToggle}
      title="Toggle app preview"
    >
      {isOpen ? 'Close Preview' : 'App Preview'}
    </button>
  );
}

export default function AppPreviewPanel({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="app-preview-overlay">
      <div className="app-preview-panel">
        <div className="app-preview-toolbar">
          <div className="app-preview-toolbar-left">
            <span className="app-preview-title">App Preview</span>
          </div>
          <div className="app-preview-toolbar-right">
            <button
              className="btn btn-xs"
              onClick={() => {
                const iframe = document.querySelector('.app-preview-iframe');
                if (iframe) iframe.src = iframe.src;
              }}
              title="Reload preview"
            >
              Reload
            </button>
            <button className="btn btn-xs" onClick={onClose}>
              Close
            </button>
          </div>
        </div>
        <div className="app-preview-frame-wrapper">
          <div
            className="app-preview-device-frame"
            style={{ width: 390, height: 844 }}
          >
            <iframe
              className="app-preview-iframe"
              src={PREVIEW_URL}
              title="App Preview"
              allow="geolocation"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
